import _debounce from 'lodash.debounce';

const PRIVATE_MIXIN_PROP_NAME = '$_onResizeMixin';
const EVENT_NAME = 'resize';

export default (callbackName = 'onResize', delay = 150) => ({
  methods: {
    [PRIVATE_MIXIN_PROP_NAME]: _debounce(function debounceOnResize(event) {
      this[callbackName](event);
    }, delay),
  },
  created() {
    window.addEventListener(EVENT_NAME, this[PRIVATE_MIXIN_PROP_NAME]);
  },
  beforeDestroy() {
    window.removeEventListener(EVENT_NAME, this[PRIVATE_MIXIN_PROP_NAME]);
  },
});



// WEBPACK FOOTER //
// ./src/mixins/responsible.js